module.exports = __webpack_public_path__ + "static/media/63.2def2334.jpg";